import { AdverseMediaIgnoreListEntry } from 'dashboard/models/report/adverse-media';
import { PoliticallyExposedPersonIgnoreListEntry } from 'dashboard/models/report/politically-exposed-person';
import {
  WatchlistIgnoreEntityEntry,
  WatchlistIgnoreListEntry,
  WatchlistMatch,
} from 'dashboard/models/report/watchlist';
import { ReportRunCustomListHitEntry } from 'dashboard/models/report-run';

export interface ReportHistory {
  timeline: ReportHistoryTimelineEntry[];
  'snapshot-matches': {
    [id: string]: WatchlistMatch[];
  };
}

export interface ReportHistoryTimelineEntry {
  type: string;
  timestamp: string;
  'run-type'?: string;
  'action-type'?: string;
  'creator-id'?: string;
  'creator-type'?: string;
  'creator-name'?: string;
  'completed-at'?: string;
  matches?: number;
  'report-snapshot-id'?: string;
  'report-snapshot-token'?: string;
  'report-run-id'?: string;
  'report-run-scheduled-at'?: string;
  'ignore-list'?: WatchlistIgnoreListEntry[];
  'ignore-list-custom-list-entity'?: ReportRunCustomListHitEntry;
  'ignore-list-watchlist-entity'?: WatchlistIgnoreEntityEntry;
  'ignore-list-media'?: AdverseMediaIgnoreListEntry;
  'ignore-list-entity'?: AdverseMediaIgnoreListEntry;
  'ignore-list-pep'?: PoliticallyExposedPersonIgnoreListEntry[];
}

export enum EntryType {
  ReportRun = 'report_run',
  Dismissal = 'dismissal',
  ReportAction = 'report_action',
}

export enum ActionType {
  ReportResumed = 'report_resumed',
  ReportPaused = 'report_paused',
}
